function woNumber(wo) {
  return String(wo?.wo_number || "").trim();
}

/** Select/list label: `[INT-OPS-2026-0001] Title` when a code exists. */
export function workOrderSelectLabel(wo) {
  if (!wo) return "";
  const title = wo.title || "";
  const num = woNumber(wo);
  return num ? `[${num}] ${title}` : title;
}

/** Timer bar style: `INT-OPS-2026-0001 — Title` when a code exists. */
export function workOrderDashLabel(wo) {
  if (!wo) return "";
  const title = wo.title || "";
  const num = woNumber(wo);
  return num ? `${num} — ${title}` : title;
}

/** Leading `[CODE] ` fragment, or empty when the WO has no number. */
export function workOrderNumberPrefix(wo) {
  const num = woNumber(wo);
  return num ? `[${num}] ` : "";
}
